<template>
  <v-container class="my-0 py-0">
    <v-row class="my-0 py-0">
      <v-col sm="12" md="3">
        <v-row>
          <v-col sm="12">
            <ProjectMilestones :project="project" />
          </v-col>
          <v-col sm="12">
            <ProjectMaterialsCard :materials="project.materials" :id="id" />
          </v-col>
        </v-row>
      </v-col>
      <v-col sm="12" md="9">
        <v-row>
          <v-col sm="12">
            <v-card>
              <v-card-title>
                <v-icon left>fas fa-clipboard</v-icon>
                Summary
                <v-spacer />
                <v-btn rounded color="primary" outlined :to="{ name: 'ProjectSummaryEditView', params: { id: id } }">
                  <v-icon left>edit</v-icon>
                  EDIT
                </v-btn>
              </v-card-title>
              <v-card-subtitle>
                Captures all fine details of the project including deliverables, materials, customer specifications, etc.
              </v-card-subtitle>
              <v-divider />
              <BaseRichTextDisplay :content="project.richtext" />
            </v-card>
          </v-col>
          <v-col sm="12" md="4">
            <ProjectAttachmentList :attachments="project.attachments" :loading="false" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Project from "../../models/Project";
import BaseRichTextDisplay from "../../components/Base/BaseRichTextDisplay";
import ProjectAttachmentList from "../../components/Project/ProjectAttachmentList";
import ProjectMilestones from "../../components/Project/ProjectMilestones";
import ProjectMaterialsCard from "../../components/Project/ProjectMaterialsCard";
export default {
  name: "ProjectSummaryView",
  components: {
    ProjectMaterialsCard,
    ProjectMilestones,
    ProjectAttachmentList,
    BaseRichTextDisplay },
  props: {
    id: {
      type: [Number, String],
      required: true
    }
  },
  computed: {
    project() {
      return Project.query()
        .with("user")
        .with("BDuser")
        .with("materials")
        .with("industry")
        .with("attachments")
        .find(parseInt(this.id))
    }
  }
}
</script>
